import { Patient, Specimen } from "pwapi";

import {
  ACCESSION_ADD_SPECIMEN,
  ACCESSION_EDIT_ACCESSION,
  ACCESSION_EDIT_SPECIMEN,
} from "app/constants";

type AccessionState = {
  patient?: Patient;
  specimens: Specimen[];
};

const initialState = {
  specimens: [],
};

const accessioningReducer = (
  state: AccessionState = initialState,
  action: any
): AccessionState => {
  switch (action.type) {
    case ACCESSION_EDIT_ACCESSION: {
      return {
        ...state,
        ...action.payload,
      };
    }
    case ACCESSION_ADD_SPECIMEN: {
      return {
        ...state,
        specimens: [...state.specimens, action.payload],
      };
    }
    case ACCESSION_EDIT_SPECIMEN: {
      const specimen: Specimen = action.payload;
      return {
        ...state,
        specimens: state.specimens.map((s) =>
          s.name === specimen.name
            ? {
                ...s,
                ...specimen,
              }
            : s
        ),
      };
    }
    default:
      return state;
  }
};
export default accessioningReducer;
